import React, { Component, } from 'react';
import c3 from 'c3';
import 'c3/c3.min.css';
import * as d3 from 'd3';
import Moment from 'react-moment';
import BarChart from './BarChart';
import _ from 'lodash';
import { AxlButton, Colors } from 'axl-reactjs-ui';

// Styles
import styles, { Statuses, Title, CollapButton } from './styles';

export default class ShipmentChart extends Component {

  constructor(props) {
    super(props);
    this.state = {
      otd_stats: [],
      isCloseCharts: false,
      isOpenAssignmentDetail: false
    }
  }
  renderChart(stats) {
    const { unrouted = 0, pending = 0, inprogress = 0, failed = 0, succeeded = 0 } = stats;

    if (!this.chart) {
      const that = this;
      this.chart = c3.generate({
        bindto: "#chart-1",
        size: {
          width: 150,
          height: 150
        },
        data: {
          labels: true,
          x: undefined,
          order: null,
          columns: [
            ['unrouted', unrouted],
            ['pending', pending],
            ['in_progress', inprogress],
            ['failed', failed],
            ['succeeded', succeeded]
          ],
          type: 'pie',
          colors: {
            unrouted: Colors.veryLightPink,
            pending: '#fbc04f',
            in_progress: '#887fff',
            succeeded: '#66b752',
            failed: '#d63031',
          },
          names: {
            unrouted: 'Unrouted',
            pending: 'Pending',
            in_progress: 'In Progress',
            succeeded: 'Succeeded',
            failed: 'Failed',
          }
        },
        tooltip: {
          grouped: false,
          format: {
            value: (value, ratio, id, index) => `${(ratio * 100).toFixed(1)}% [${value}]`
          }
        },
        donut: {
          label: {
            show: false
          }
        },
        legend: {
            hide: true,
            // amount of padding to put between each legend element
            // padding: 5,
            // item: {
            //     tile: {
            //       width: 10,
            //       height: 10
            //     }
            // }
        }
      });
      d3.select('.chart')
        .insert('div')
        .attr('class', 'legend')
          .style('width', '80px')
          .style('margin', '0 auto')
          .style('text-align', 'left')
        .selectAll('div')
        .data(['unrouted', 'pending', 'in_progress', 'succeeded', 'failed'])
        .enter().append('div')
        .attr('data-id', function (id) { return id; })
        // .html(function (id) { return id; })
        .each(function (id) {
          d3.select(this).append('span').attr('class', 'circle')
            .style('background-color', that.chart.color(id))
            .style('width', '10px')
            .style('height', '10px')
            .style('display', 'inline-block')
            .style('margin-right', '10px')
            .style('border-radius', '50%')
            .style('vertical-align', 'middle')
        })
        .insert('span')
        .html(function (id) {
          return that.chart.data.names(id)[id];
        })
          .style('font-size', '10px')
        .on('mouseover', function (id) {
          that.chart.focus(id);
        })
        .on('mouseout', function (id) {
          that.chart.revert();
        })
        .on('click', function (id) {
          that.chart.toggle(id);
        });
    } else {
      this.chart.load({columns:[
        ['unrouted', unrouted],
        ['pending', pending],
        ['in_progress', inprogress],
        ['succeeded', succeeded],
        ['failed', failed],
      ]})
    }
  }

  componentWillReceiveProps(props) {
    const { stats = {} } = props;
    const { unrouted = 0, pending = 0, inprogress = 0, early = 0, late = 0, failed = 0, succeeded = 0 } = stats;
    this.setState({
      otd_stats: [{
        value: early,
        title: 'Early',
        color: '#a5ccec'
      },{
        value: succeeded - early - late,
        title: 'On Time',
        color: '#66b752'
      },{
        value: late,
        title: 'Late',
        color: '#273c75'
      },{
        value: failed,
        title: 'Failed',
        color: '#d63031'
      }
      ]
    });
    this.renderChart(stats)
  }

  componentDidMount () {
    const { stats = {} } = this.props;
    this.renderChart(stats);
  }

  toggleAssignmentDetail = () => {
    const { stats = {} } = this.props;
    this.setState({isOpenAssignmentDetail: !this.state.isOpenAssignmentDetail})
  };

  onToggleChart = () => {
    this.props.onCollapse();
    this.setState({isCloseCharts: !this.state.isCloseCharts})
  };

  render() {
    const { isOpenAssignmentDetail, isCloseCharts } = this.state;
    const dateTitleStyle = !isCloseCharts ? styles.dateTitleOpen : styles.dateTitleClose;
    const { stats = {} } = this.props
    const { unrouted = 0, pending = 0, inprogress = 0, early = 0, late = 0, failed = 0, succeeded = 0 } = stats

    return <div style={styles.container}>
      <div style={styles.title}>
        {/*!isCloseCharts && <AxlButton tiny bg={`${isOpenAssignmentDetail ? 'none' : 'gray'}`}
          style={styles.toggleButton}
          ico={{className: 'fa fa-info', style: {fontSize: '20px'}}}
          onClick={this.toggleAssignmentDetail} />*/}
        <div style={{...styles.innerTitle, ...{textAlign: !isCloseCharts ? 'center' : 'left'}}}>
          <Title><Moment format={'MMM DD, YYYY'}>{this.props.date}</Moment>{` Shipment Breakdown`}</Title>
        </div>
        <CollapButton onClick={this.onToggleChart}>{!isCloseCharts ? `HIDE` : `SHOW`}</CollapButton>
      </div>
      <div style={{...{display: !isCloseCharts ? 'block' : 'none'}}}>
        <div style={{...styles.panelContainer, ...{display: isOpenAssignmentDetail ? 'flex' : 'none'}}}>
          <div style={styles.innerPanelContainer}>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['default']}}}>TOTAL SHIPMENTS:</label>{stats.total}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['default']}}}>TOTAL COMPLETED:</label>{stats.succeeded + stats.failed}</div>
            <br />
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['early']}}}>{`EARLY:`}</label>{stats.early}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['failed']}}}>{`FAILED:`}</label>{stats.failed}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['in_progress']}}}>{`INPROGRESS:`}</label>{stats.inprogress}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['late']}}}>{`LATE:`}</label>{stats.late}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['pending']}}}>{`PENDING:`}</label>{stats.pending}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['succeeded']}}}>{`SUCCESSED:`}</label>{stats.succeeded}</div>
            <div style={styles.rowTitle}><label style={{...styles.rowLabel, ...{color: Statuses['unrouted']}}}>{`UNROUTED:`}</label>{stats.unrouted}</div>
          </div>
        </div>
        <div style={{...styles.panelContainer, ...{display: isOpenAssignmentDetail ? 'none' : 'flex'}}}>
          <div style={styles.pane} className="chart">
            <div style={styles.info}>total shipments<br /><span style={styles.shipmentTotal}>{this.props.stats.total}</span></div>
            <div id="chart-1" style={styles.chart} />
          </div>
          <div style={styles.pane}>
            <div style={styles.info}>total completed<br /><span style={styles.shipmentTotal}>{succeeded + failed}</span></div>
            <BarChart height='160px' width={30} data = {this.state.otd_stats} />
          </div>
        </div>
      </div>
    </div>
  }
}
